<template>
  <div
    class="flex min-h-56 flex-col items-center justify-center rounded-base border border-dashed border-light-300 bg-light-100 px-6 py-10 text-center dark:border-grey-dark dark:bg-dark"
  >
    <span
      class="flex h-12 w-12 items-center justify-center rounded-full bg-gold/15"
      aria-hidden="true"
    >
      <Icon :icon="icon" class="text-xl text-black dark:text-white" />
    </span>
    <h3 class="mt-4 text-xl text-black dark:text-white">{{ title }}</h3>
    <p
      class="mt-2 max-w-xl text-sm leading-relaxed text-grey dark:text-grey-light"
    >
      {{ description }}
    </p>
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    title: string;
    description: string;
    icon?: string;
  }>(),
  {
    icon: "layout-left",
  },
);
</script>
